<div *ngIf="showAccumulator.individual">
    <h5 class="h4 ip-accumulator-title">{{ insurancePlanLevel.Individual | translate}}</h5>
    <div *ngFor="let accumulator of insurancePlanAccumulators?.accumulatorData">
        <div
            *ngIf="isRelevantIndividualAccumulator(accumulator)"
            class="ip-accumulator-container-with-background">
                <accumulator-item
                [accumulator]="accumulator"></accumulator-item>
        </div>
    </div>
</div>
<div *ngIf="showAccumulator.family">
    <h5 class="h4 ip-accumulator-title">{{ insurancePlanLevel.Family | translate}}</h5>
    <div *ngFor="let accumulator of insurancePlanAccumulators?.accumulatorData">
        <div
            *ngIf="isRelevantFamilyAccumulator(accumulator)"
            [class.ip-accumulator-container-no-background]='showAccumulator.individual'
            [class.ip-accumulator-container-with-background]='!showAccumulator.individual'>
            <accumulator-item
                [accumulator]="accumulator"></accumulator-item>
        </div>
    </div>
</div>